import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { authService } from '../../services/authService';
import Logo from '../../components/common/Logo';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.resetPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Bir hata olustu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-main)', padding: '2rem', backgroundImage: 'radial-gradient(circle at 20% 20%, rgba(111, 78, 55, 0.05) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(111, 78, 55, 0.05) 0%, transparent 40%)' }}>
      <div style={{ width: '100%', maxWidth: 480, padding: '3.5rem', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 32, boxShadow: 'var(--shadow-md)', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: 'linear-gradient(90deg, transparent, var(--primary), transparent)' }} />

        <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'flex-start' }}>
          <Link to="/login" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.875rem', fontWeight: 600, padding: '8px 16px', borderRadius: 12, background: 'var(--bg-main)', border: '1px solid var(--border)' }}>
            <ArrowRight size={16} style={{ transform: 'rotate(180deg)' }} /> Girise Don
          </Link>
        </div>

        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem', textDecoration: 'none' }}>
            <Logo size={64} />
            <span style={{ fontSize: '2.5rem', fontWeight: 600, fontFamily: 'var(--font-logo)', position: 'relative', top: '3px', letterSpacing: '-0.02em', color: 'var(--text-main)' }}>ugra</span>
          </Link>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--text-main)', marginBottom: '0.75rem', letterSpacing: '-0.02em' }}>Sifremi Unuttum</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9375rem', lineHeight: 1.6 }}>E-posta adresinize sifre sifirlama baglantisi gonderecegiz.</p>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '2rem', background: '#f0fdf4', borderRadius: 12, border: '1px solid #bbf7d0' }}>
            <CheckCircle size={48} color="#16a34a" style={{ marginBottom: '1rem' }} />
            <h3 style={{ color: '#16a34a', marginBottom: '0.5rem', fontWeight: 700 }}>E-posta Gonderildi</h3>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
              <strong>{email}</strong> adresine sifre sifirlama baglantisi gonderdik. Lutfen e-postanizi kontrol edin.
            </p>
            <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginTop: '1.5rem', color: 'var(--primary)', textDecoration: 'none', fontWeight: 700, fontSize: '0.9375rem' }}>
              <ArrowRight size={16} style={{ transform: 'rotate(180deg)' }} /> Girise Don
            </Link>
          </div>
        ) : (
          <>
            {error && (
              <div style={{ background: '#fff1f2', color: '#e11d48', padding: '1rem', borderRadius: 12, marginBottom: '2rem', fontSize: '0.875rem', fontWeight: 500, textAlign: 'center', border: '1px solid #ffe4e6' }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1.5rem', position: 'relative' }}>
                <label style={{ display: 'block', marginBottom: '0.625rem', fontSize: '0.8125rem', fontWeight: 600, color: 'var(--text-main)', textTransform: 'uppercase', letterSpacing: '0.025em' }}>E-posta Adresi</label>
                <Mail style={{ position: 'absolute', left: 16, top: 42, color: 'var(--text-muted)' }} size={20} />
                <input
                  type="email"
                  placeholder="e-posta@isletme.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ width: '100%', padding: '0 16px 0 48px', height: 54, borderRadius: 14, border: '1.5px solid var(--border)', background: 'var(--bg-main)', fontSize: '0.9375rem', color: 'var(--text-main)' }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{ width: '100%', height: 54, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, fontSize: '1rem', fontWeight: 700, marginTop: '2.5rem', background: 'var(--primary)', color: 'white', border: 'none', borderRadius: 14, cursor: 'pointer', boxShadow: '0 4px 12px rgba(111, 78, 55, 0.15)', opacity: loading ? 0.6 : 1 }}
              >
                {loading ? 'Gonderiliyor...' : 'Sifirlama Baglantisi Gonder'}
                {!loading && <ArrowRight size={20} />}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
